import '../App.css';
import { FaBars, FaTimes } from "react-icons/fa";
import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';

const Header = () => {

  const navigate = useNavigate();

  const [menuOpen, setMenuOpen] = useState(false); // State for toggling menu

  const handleLinkClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" }); // Scroll to the top
  }

  const pageHandler = () => {
    navigate("/");
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleLinkClickSide = () => {
    window.scrollTo({ top: 0, behavior: "smooth" }); // Scroll to the top
    setMenuOpen(!menuOpen);
  }

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      <header>
        <nav>
          <div className="logo">
            <span className="logo-name" onClick={pageHandler}>
              <img
                width="50"
                height="50"
                src="https://img.icons8.com/nolan/64/avermedia.png"
                alt="avermedia"
              />
              Vortex Gym
            </span>
          </div>
          {/* Hamburger Icon */}
          <div className="hamburger" onClick={toggleMenu}>
            {menuOpen ? "" : <FaBars size={32} color="#fff" />}
          </div>
          {/* Desktop Nav Links */}
          <ul className={`nav-links ${menuOpen ? 'open' : ''}`}>
            <li><NavLink to="/" activeClassName="active" onClick={toggleMenu && handleLinkClick}>Home</NavLink></li>
            <li><NavLink to="/about-us" activeClassName="active" onClick={toggleMenu && handleLinkClick}>About</NavLink></li>
            <li><NavLink to="/classes" activeClassName="active" onClick={toggleMenu && handleLinkClick}>Classes</NavLink></li>
            <li><NavLink to="/pricing" activeClassName="active" onClick={toggleMenu && handleLinkClick}>Pricing</NavLink></li>
            <li><NavLink to="/contact" activeClassName="active" onClick={toggleMenu && handleLinkClick}>Contact</NavLink></li>
          </ul>
        </nav>
        {/* Side Menu */}
        <div className={`side-menu ${menuOpen ? 'open' : ''}`}>
          <div className="close-btn" onClick={toggleMenu}>
            <FaTimes />
          </div>
          <NavLink to="/" onClick={toggleMenu && handleLinkClickSide}>Home</NavLink>
          <NavLink to="/about-us" onClick={toggleMenu && handleLinkClickSide}>About</NavLink>
          <NavLink to="/classes" onClick={toggleMenu && handleLinkClickSide}>Classes</NavLink>
          <NavLink to="/pricing" onClick={toggleMenu && handleLinkClickSide}>Pricing</NavLink>
          <NavLink to="/contact" onClick={toggleMenu && handleLinkClickSide}>Contact</NavLink>
        </div>
      </header>
    </>
  );
};

export default Header;
